// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-4dcd3b1f]{margin-top:1.5rem;margin-bottom:.2rem;font-weight:600;font-size:1.25rem;color:#0098dd}p[data-v-4dcd3b1f]{line-height:1.6rem}.list[data-v-4dcd3b1f]{list-style-type:upper-roman}.list-a[data-v-4dcd3b1f]{list-style-type:lower-alpha}li[data-v-4dcd3b1f]{padding-left:36px}", ""]);
// Exports
module.exports = exports;
